import { render, staticRenderFns } from "./UiSlideOver.vue?vue&type=template&id=3cc2cef5&"
import script from "./UiSlideOver.vue?vue&type=script&lang=js&"
export * from "./UiSlideOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports